<template>

  <div class="swiper-container" ref="container" :class="outer_cls" :id="id">

      <div class="swiper-wrapper">

        <slot></slot>

      </div>

      <div class="swiper-pagination"></div>

      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>

  </div>

</div>
</template>

<script>

import assignin from 'lodash.assignin'
import Swiper from 'swiper'

export default {
  props: [ 'config', 'slidescount' ],
  data(){ return {
     
    uid:  undefined,    

    swiperInstance: undefined,

    default_config: {
      //direction: 'vertical',
      //loop: true,
      autoHeight: true, 
      
      pagination: {
        el: '.swiper-pagination',
      },

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',      
      },

      //autoplay: {
      //  delay: 8000,
      //  disableOnInteraction: true,
      //},

      on: {
        init: function () {
          console.log('swiper initialized')
          console.log('slides count: '+ this.slidescount)
              

        },
      },

      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      

    },

  }},
  computed:{
    
    id(){ return 'swiper_'+ this.uid },

    mergedConfig(){

      // extend settings on top of default config
      return assignin( {}, this.default_config, this.config )      

    },
    

    outer_cls(){
      var cls = {}
      if( this.slidescount ) cls['slidescount-'+this.slidescount] = true
      return cls
    },
    
  },
  methods: {
    
    //onResize(){ },
    
  },  
  
  created(){
    
    this.uid = parseInt(Math.random() * 9990)

    //window.addEventListener('resize', this.onResize)

  },

  mounted(){
    
    var el = this.$refs.container 
    this.swiperInstance = new Swiper (el, this.mergedConfig)
    
  },

  destroyed(){
    
    if( this.swiperInstance ) this.swiperInstance.destroy()

    //window.removeEventListener('resize', this.onResize)

  },

}
</script>


// WEBPACK FOOTER //
// src/components/Swiper.vue